import { ArrowRight } from 'lucide-react'

type EmptyViewProps = {
  image: React.ReactNode
  title: string
  description: string
  onPress?: () => void
}

const EmptyView = ({ image, title, description, onPress }: EmptyViewProps) => {
  return (
    <div className="relative flex h-[120px] w-full flex-row items-start gap-2.5 overflow-hidden rounded-xl border border-lightBorder bg-white p-0 shadow-[0_3px_10px_rgba(220,219,218,0.25)] md:h-[142px] md:gap-5">
      <div className="relative h-[120px] w-[90px] overflow-hidden rounded-l-xl md:h-[140px] md:w-[110px]">{image}</div>

      <div className="flex h-full flex-col justify-center gap-1.5 py-5 pr-5">
        <h3 className="text-base font-bold leading-normal text-foreground sm:text-lg md:text-xl">{title}</h3>
        <p className="text-xs font-medium leading-snug text-muted sm:text-[14px] md:text-base">{description}</p>
      </div>

      {onPress && (
        <button
          onClick={onPress}
          className="absolute bottom-3 right-3 flex size-[30px] items-center justify-center rounded-full border border-lightBorder bg-white shadow-[0_3px_10px_rgba(220,219,218,0.25)]"
        >
          <ArrowRight size={16} />
        </button>
      )}
    </div>
  )
}

export default EmptyView
